import { Component } from '@angular/core';

import { RouterModule } from '@angular/router';
import { AppMenuitem } from './app.menuitem';

@Component({
	selector: 'wo-menu',
	standalone: true,
	imports: [AppMenuitem, RouterModule],
	template: `<ul class="layout-menu">
		@for (item of model; track item; let i = $index) {
			@if (!item.separator) {
				<li wo-menuitem [item]="item" [index]="i" [root]="true"></li>
			}
			@if (item.separator) {
				<li class="menu-separator"></li>
			}
		}
	</ul>`,
})
export class AppMenu {
	model: any[] = [];

	ngOnInit() {
		this.model = [
			{
				label: 'menu.pages.title',
				icon: 'pi pi-home',
				items: [
					{
						label: 'menu.pages.home',
						icon: 'pi pi-fw pi-home',
						routerLink: ['home'],
					},
					{
						label: 'menu.pages.destinations',
						icon: 'pi pi-fw pi-list',
						routerLink: ['destinations'],
					},
					{
						label: 'menu.pages.lastMinute',
						icon: 'pi pi-fw pi-clock',
						routerLink: ['last-minute'],
					},
					{
						label: 'menu.pages.firstMinute',
						icon: 'pi pi-fw pi-clock',
						routerLink: ['first-minute'],
					},
					{
						label: 'menu.pages.premium',
						icon: 'pi pi-fw pi-star',
						routerLink: ['premium'],
					},
					{
						label: 'menu.pages.specialOffer',
						icon: 'pi pi-fw pi-tag',
						routerLink: ['special-offer'],
					},
					{
						label: 'menu.pages.menuDestination',
						icon: 'pi pi-fw pi-align-justify',
						routerLink: ['menu-destination'],
					},
					{
						label: 'menu.pages.headerConfig',
						icon: 'pi pi-fw pi-bars',
						routerLink: ['header-config'],
					},
				],
			},
			{
				label: 'menu.metadata.title',
				icon: 'pi pi-home',
				items: [
					{
						label: 'menu.metadata.metadata',
						icon: 'pi pi-fw pi-google',
						routerLink: ['metadata'],
					},
				],
			},
		];
	}
}
